// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as DTS_Types from "../DTS.Types/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect_Unsafe from "../Effect.Unsafe/index.js";
import * as Ouroboros_Models_Brands_ClientID from "../Ouroboros.Models.Brands.ClientID/index.js";
import * as Ouroboros_Models_Brands_DocumentID from "../Ouroboros.Models.Brands.DocumentID/index.js";
import * as Ouroboros_Models_Brands_JwtSubscriptionStatus from "../Ouroboros.Models.Brands.JwtSubscriptionStatus/index.js";
import * as Ouroboros_Models_Brands_ListingInferenceReviewPortal from "../Ouroboros.Models.Brands.ListingInferenceReviewPortal/index.js";
import * as Ouroboros_Models_Brands_ProbingQuestions from "../Ouroboros.Models.Brands.ProbingQuestions/index.js";
import * as Ouroboros_Models_Brands_ProjectID from "../Ouroboros.Models.Brands.ProjectID/index.js";
import * as Ouroboros_Models_Brands_PromoCode from "../Ouroboros.Models.Brands.PromoCode/index.js";
import * as Ouroboros_Models_Brands_SectionID from "../Ouroboros.Models.Brands.SectionID/index.js";
import * as Ouroboros_Programs_UrlEncoding from "../Ouroboros.Programs.UrlEncoding/index.js";
import * as Ouroboros_Services_Clients_Interop_Option from "../Ouroboros.Services.Clients.Interop.Option/index.js";
import * as Ouroboros_Services_Clients_Interop_Types from "../Ouroboros.Services.Clients.Interop.Types/index.js";
import * as TsBridge_Class from "../TsBridge.Class/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var bind = /* #__PURE__ */ Control_Bind.bind(TsBridge_Monad.bindTsBridgeM);
var tsBridge = /* #__PURE__ */ TsBridge_Class.tsBridge(/* #__PURE__ */ Ouroboros_Services_Clients_Interop_Types.tsBridgeOptionTs(Ouroboros_Models_Brands_ClientID.tsBridgeClientID));
var tsBridge1 = /* #__PURE__ */ TsBridge_Class.tsBridge(Ouroboros_Models_Brands_ClientID.tsBridgeClientID);
var tsBridge2 = /* #__PURE__ */ TsBridge_Class.tsBridge(/* #__PURE__ */ Ouroboros_Services_Clients_Interop_Types.tsBridgeOptionTs(Ouroboros_Models_Brands_DocumentID.tsBridgeDocumentID));
var tsBridge3 = /* #__PURE__ */ TsBridge_Class.tsBridge(/* #__PURE__ */ Ouroboros_Services_Clients_Interop_Types.tsBridgeOptionTs(Ouroboros_Models_Brands_SectionID.tsBridgeSectionID));
var tsBridge4 = /* #__PURE__ */ TsBridge_Class.tsBridge(/* #__PURE__ */ Ouroboros_Services_Clients_Interop_Types.tsBridgeOptionTs(Ouroboros_Models_Brands_ProjectID.tsBridgeProjectID));
var tsBridge5 = /* #__PURE__ */ TsBridge_Class.tsBridge(Ouroboros_Models_Brands_ProjectID.tsBridgeProjectID);
var tsBridge6 = /* #__PURE__ */ TsBridge_Class.tsBridge(Ouroboros_Models_Brands_ProbingQuestions.tsBridgeProbingQuestions);
var tsBridge7 = /* #__PURE__ */ TsBridge_Class.tsBridge(/* #__PURE__ */ Ouroboros_Services_Clients_Interop_Types.tsBridgeOptionTs(Ouroboros_Models_Brands_JwtSubscriptionStatus.tsBridgeJwtSubscriptionSt));
var tsBridge8 = /* #__PURE__ */ TsBridge_Class.tsBridge(Ouroboros_Models_Brands_PromoCode.tsBridgePromoCode);
var tsBridge9 = /* #__PURE__ */ TsBridge_Class.tsBridge(/* #__PURE__ */ Ouroboros_Services_Clients_Interop_Types.tsBridgeOptionTs(Ouroboros_Models_Brands_ListingInferenceReviewPortal.tsBridgeListingInferenceListingId));
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var Home = /* #__PURE__ */ (function () {
    function Home() {

    };
    Home.value = new Home();
    return Home;
})();
var Login = /* #__PURE__ */ (function () {
    function Login() {

    };
    Login.value = new Login();
    return Login;
})();
var CreateAccount = /* #__PURE__ */ (function () {
    function CreateAccount() {

    };
    CreateAccount.value = new CreateAccount();
    return CreateAccount;
})();
var PasswordResetRequest = /* #__PURE__ */ (function () {
    function PasswordResetRequest() {

    };
    PasswordResetRequest.value = new PasswordResetRequest();
    return PasswordResetRequest;
})();
var PasswordResetComplete = /* #__PURE__ */ (function () {
    function PasswordResetComplete() {

    };
    PasswordResetComplete.value = new PasswordResetComplete();
    return PasswordResetComplete;
})();
var EmailVerify = /* #__PURE__ */ (function () {
    function EmailVerify() {

    };
    EmailVerify.value = new EmailVerify();
    return EmailVerify;
})();
var InviteAccept = /* #__PURE__ */ (function () {
    function InviteAccept() {

    };
    InviteAccept.value = new InviteAccept();
    return InviteAccept;
})();
var DocumentSelection = /* #__PURE__ */ (function () {
    function DocumentSelection() {

    };
    DocumentSelection.value = new DocumentSelection();
    return DocumentSelection;
})();
var PageCounter = /* #__PURE__ */ (function () {
    function PageCounter() {

    };
    PageCounter.value = new PageCounter();
    return PageCounter;
})();
var ProjectPageCounter = /* #__PURE__ */ (function () {
    function ProjectPageCounter(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    ProjectPageCounter.create = function (value0) {
        return function (value1) {
            return new ProjectPageCounter(value0, value1);
        };
    };
    return ProjectPageCounter;
})();
var Clients = /* #__PURE__ */ (function () {
    function Clients() {

    };
    Clients.value = new Clients();
    return Clients;
})();
var ClientsExplorer = /* #__PURE__ */ (function () {
    function ClientsExplorer(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    ClientsExplorer.create = function (value0) {
        return function (value1) {
            return new ClientsExplorer(value0, value1);
        };
    };
    return ClientsExplorer;
})();
var DocumentCreation = /* #__PURE__ */ (function () {
    function DocumentCreation() {

    };
    DocumentCreation.value = new DocumentCreation();
    return DocumentCreation;
})();
var Feedback = /* #__PURE__ */ (function () {
    function Feedback() {

    };
    Feedback.value = new Feedback();
    return Feedback;
})();
var SdeWorkbook = /* #__PURE__ */ (function () {
    function SdeWorkbook() {

    };
    SdeWorkbook.value = new SdeWorkbook();
    return SdeWorkbook;
})();
var Account = /* #__PURE__ */ (function () {
    function Account() {

    };
    Account.value = new Account();
    return Account;
})();
var AdminUsers = /* #__PURE__ */ (function () {
    function AdminUsers() {

    };
    AdminUsers.value = new AdminUsers();
    return AdminUsers;
})();
var AdminPlan = /* #__PURE__ */ (function () {
    function AdminPlan() {

    };
    AdminPlan.value = new AdminPlan();
    return AdminPlan;
})();
var Review = /* #__PURE__ */ (function () {
    function Review(value0) {
        this.value0 = value0;
    };
    Review.create = function (value0) {
        return new Review(value0);
    };
    return Review;
})();
var DocumentPrompt = /* #__PURE__ */ (function () {
    function DocumentPrompt(value0) {
        this.value0 = value0;
    };
    DocumentPrompt.create = function (value0) {
        return new DocumentPrompt(value0);
    };
    return DocumentPrompt;
})();
var DocumentRefine = /* #__PURE__ */ (function () {
    function DocumentRefine(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    DocumentRefine.create = function (value0) {
        return function (value1) {
            return new DocumentRefine(value0, value1);
        };
    };
    return DocumentRefine;
})();
var DocumentFinalEdits = /* #__PURE__ */ (function () {
    function DocumentFinalEdits(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    DocumentFinalEdits.create = function (value0) {
        return function (value1) {
            return new DocumentFinalEdits(value0, value1);
        };
    };
    return DocumentFinalEdits;
})();
var DocumentDetailsPrompt = /* #__PURE__ */ (function () {
    function DocumentDetailsPrompt(value0) {
        this.value0 = value0;
    };
    DocumentDetailsPrompt.create = function (value0) {
        return new DocumentDetailsPrompt(value0);
    };
    return DocumentDetailsPrompt;
})();
var ChooseSubscription = /* #__PURE__ */ (function () {
    function ChooseSubscription(value0) {
        this.value0 = value0;
    };
    ChooseSubscription.create = function (value0) {
        return new ChooseSubscription(value0);
    };
    return ChooseSubscription;
})();
var PaymentSetup = /* #__PURE__ */ (function () {
    function PaymentSetup(value0) {
        this.value0 = value0;
    };
    PaymentSetup.create = function (value0) {
        return new PaymentSetup(value0);
    };
    return PaymentSetup;
})();
var DemographicSurvey = /* #__PURE__ */ (function () {
    function DemographicSurvey(value0) {
        this.value0 = value0;
    };
    DemographicSurvey.create = function (value0) {
        return new DemographicSurvey(value0);
    };
    return DemographicSurvey;
})();
var ListingInferenceReviewPortal = /* #__PURE__ */ (function () {
    function ListingInferenceReviewPortal(value0) {
        this.value0 = value0;
    };
    ListingInferenceReviewPortal.create = function (value0) {
        return new ListingInferenceReviewPortal(value0);
    };
    return ListingInferenceReviewPortal;
})();
var ContextPreviewConsole = /* #__PURE__ */ (function () {
    function ContextPreviewConsole(value0) {
        this.value0 = value0;
    };
    ContextPreviewConsole.create = function (value0) {
        return new ContextPreviewConsole(value0);
    };
    return ContextPreviewConsole;
})();
var StatementClassifier = /* #__PURE__ */ (function () {
    function StatementClassifier() {

    };
    StatementClassifier.value = new StatementClassifier();
    return StatementClassifier;
})();
var routeStatementClassifier = /* #__PURE__ */ (function () {
    return StatementClassifier.value;
})();
var routeSdeWorkbook = /* #__PURE__ */ (function () {
    return SdeWorkbook.value;
})();
var routeReviewWithDocument = function (docId) {
    return new Review(Ouroboros_Services_Clients_Interop_Option.some(docId));
};
var routeReview = /* #__PURE__ */ (function () {
    return new Review(Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit));
})();
var routeRecord = function (tag) {
    return function (fields) {
        return new DTS_Types.TsTypeRecord(append([ new DTS_Types.TsRecordField("tag", {
            readonly: true,
            optional: false
        }, new DTS_Types.TsTypeTypelevelString(tag)) ])(fields));
    };
};
var tsBridgeRoute = {
    tsBridge: function (v) {
        return bind(tsBridge(Type_Proxy["Proxy"].value))(function (clientIdType) {
            return bind(tsBridge1(Type_Proxy["Proxy"].value))(function (projectPageCounterClientIdType) {
                return bind(tsBridge2(Type_Proxy["Proxy"].value))(function (documentIdType) {
                    return bind(tsBridge3(Type_Proxy["Proxy"].value))(function (sectionIdType) {
                        return bind(tsBridge4(Type_Proxy["Proxy"].value))(function (projectIdType) {
                            return bind(tsBridge5(Type_Proxy["Proxy"].value))(function (projectPageCounterProjectIdType) {
                                return bind(tsBridge6(Type_Proxy["Proxy"].value))(function (probingType) {
                                    return bind(tsBridge7(Type_Proxy["Proxy"].value))(function (statusType) {
                                        return bind(tsBridge8(Type_Proxy["Proxy"].value))(function (promoCodeType) {
                                            return bind(tsBridge9(Type_Proxy["Proxy"].value))(function (listingInferenceListingIdType) {
                                                return pure(new DTS_Types.TsTypeUnion([ routeRecord("Home")([  ]), routeRecord("Login")([  ]), routeRecord("CreateAccount")([  ]), routeRecord("PasswordResetRequest")([  ]), routeRecord("PasswordResetComplete")([  ]), routeRecord("EmailVerify")([  ]), routeRecord("InviteAccept")([  ]), routeRecord("DocumentSelection")([  ]), routeRecord("PageCounter")([  ]), routeRecord("ProjectPageCounter")([ new DTS_Types.TsRecordField("clientId", {
                                                    readonly: true,
                                                    optional: false
                                                }, projectPageCounterClientIdType), new DTS_Types.TsRecordField("projectId", {
                                                    readonly: true,
                                                    optional: false
                                                }, projectPageCounterProjectIdType) ]), routeRecord("Clients")([  ]), routeRecord("ClientsExplorer")([ new DTS_Types.TsRecordField("clientId", {
                                                    readonly: true,
                                                    optional: false
                                                }, clientIdType), new DTS_Types.TsRecordField("projectId", {
                                                    readonly: true,
                                                    optional: false
                                                }, projectIdType) ]), routeRecord("DocumentCreation")([  ]), routeRecord("Feedback")([  ]), routeRecord("SdeWorkbook")([  ]), routeRecord("Account")([  ]), routeRecord("AdminUsers")([  ]), routeRecord("AdminPlan")([  ]), routeRecord("Review")([ new DTS_Types.TsRecordField("documentId", {
                                                    readonly: true,
                                                    optional: false
                                                }, documentIdType) ]), routeRecord("DocumentPrompt")([ new DTS_Types.TsRecordField("question", {
                                                    readonly: true,
                                                    optional: false
                                                }, probingType) ]), routeRecord("DocumentRefine")([ new DTS_Types.TsRecordField("documentId", {
                                                    readonly: true,
                                                    optional: false
                                                }, documentIdType), new DTS_Types.TsRecordField("sectionId", {
                                                    readonly: true,
                                                    optional: false
                                                }, sectionIdType) ]), routeRecord("DocumentFinalEdits")([ new DTS_Types.TsRecordField("documentId", {
                                                    readonly: true,
                                                    optional: false
                                                }, documentIdType), new DTS_Types.TsRecordField("sectionId", {
                                                    readonly: true,
                                                    optional: false
                                                }, sectionIdType) ]), routeRecord("DocumentDetailsPrompt")([ new DTS_Types.TsRecordField("question", {
                                                    readonly: true,
                                                    optional: false
                                                }, probingType) ]), routeRecord("ChooseSubscription")([ new DTS_Types.TsRecordField("status", {
                                                    readonly: true,
                                                    optional: false
                                                }, statusType) ]), routeRecord("PaymentSetup")([ new DTS_Types.TsRecordField("setupIntentSecret", {
                                                    readonly: true,
                                                    optional: false
                                                }, DTS_Types.TsTypeString.value) ]), routeRecord("DemographicSurvey")([ new DTS_Types.TsRecordField("promoCode", {
                                                    readonly: true,
                                                    optional: false
                                                }, promoCodeType) ]), routeRecord("ListingInferenceReviewPortal")([ new DTS_Types.TsRecordField("listingId", {
                                                    readonly: true,
                                                    optional: false
                                                }, listingInferenceListingIdType) ]), routeRecord("ContextPreviewConsole")([ new DTS_Types.TsRecordField("listingId", {
                                                    readonly: true,
                                                    optional: false
                                                }, listingInferenceListingIdType) ]), routeRecord("StatementClassifier")([  ]) ]));
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    });
                });
            });
        });
    }
};
var routeProjectPageCounter = /* #__PURE__ */ (function () {
    return ProjectPageCounter.create;
})();
var routePaymentSetup = /* #__PURE__ */ (function () {
    return PaymentSetup.create;
})();
var routePasswordResetRequest = /* #__PURE__ */ (function () {
    return PasswordResetRequest.value;
})();
var routePasswordResetComplete = /* #__PURE__ */ (function () {
    return PasswordResetComplete.value;
})();
var routePageCounter = /* #__PURE__ */ (function () {
    return PageCounter.value;
})();
var routeLogin = /* #__PURE__ */ (function () {
    return Login.value;
})();
var routeListingInferenceReviewPortalWithListing = function (listingId) {
    return new ListingInferenceReviewPortal(Ouroboros_Services_Clients_Interop_Option.some(listingId));
};
var routeListingInferenceReviewPortal = /* #__PURE__ */ (function () {
    return new ListingInferenceReviewPortal(Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit));
})();
var routeInviteAccept = /* #__PURE__ */ (function () {
    return InviteAccept.value;
})();
var routeHome = /* #__PURE__ */ (function () {
    return Home.value;
})();
var routeFeedback = /* #__PURE__ */ (function () {
    return Feedback.value;
})();
var routeEmailVerify = /* #__PURE__ */ (function () {
    return EmailVerify.value;
})();
var routeDocumentSelection = /* #__PURE__ */ (function () {
    return DocumentSelection.value;
})();
var routeDocumentRefineWithContext = function (documentId) {
    return function (sectionId) {
        return new DocumentRefine(Ouroboros_Services_Clients_Interop_Option.some(documentId), Ouroboros_Services_Clients_Interop_Option.some(sectionId));
    };
};
var routeDocumentRefine = /* #__PURE__ */ (function () {
    return new DocumentRefine(Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit), Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit));
})();
var routeDocumentPrompt = /* #__PURE__ */ (function () {
    return DocumentPrompt.create;
})();
var routeDocumentFinalEditsWithContext = function (documentId) {
    return function (sectionId) {
        return new DocumentFinalEdits(Ouroboros_Services_Clients_Interop_Option.some(documentId), Ouroboros_Services_Clients_Interop_Option.some(sectionId));
    };
};
var routeDocumentFinalEdits = /* #__PURE__ */ (function () {
    return new DocumentFinalEdits(Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit), Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit));
})();
var routeDocumentDetailsPrompt = /* #__PURE__ */ (function () {
    return DocumentDetailsPrompt.create;
})();
var routeDocumentCreation = /* #__PURE__ */ (function () {
    return DocumentCreation.value;
})();
var routeDemographicSurvey = /* #__PURE__ */ (function () {
    return DemographicSurvey.create;
})();
var routeCreateAccount = /* #__PURE__ */ (function () {
    return CreateAccount.value;
})();
var routeContextPreviewConsoleWithListing = function (listingId) {
    return new ContextPreviewConsole(Ouroboros_Services_Clients_Interop_Option.some(listingId));
};
var routeContextPreviewConsole = /* #__PURE__ */ (function () {
    return new ContextPreviewConsole(Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit));
})();
var routeClientsExplorerWithProject = function (clientId) {
    return function (projectId) {
        return new ClientsExplorer(Ouroboros_Services_Clients_Interop_Option.some(clientId), Ouroboros_Services_Clients_Interop_Option.some(projectId));
    };
};
var routeClientsExplorerWithClient = function (clientId) {
    return new ClientsExplorer(Ouroboros_Services_Clients_Interop_Option.some(clientId), Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit));
};
var routeClientsExplorer = /* #__PURE__ */ (function () {
    return ClientsExplorer.create;
})();
var routeClients = /* #__PURE__ */ (function () {
    return Clients.value;
})();
var routeChooseSubscriptionWithStatus = function (value) {
    return new ChooseSubscription(Ouroboros_Services_Clients_Interop_Option.some(value));
};
var routeChooseSubscription = /* #__PURE__ */ (function () {
    return new ChooseSubscription(Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit));
})();
var routeAdminUsers = /* #__PURE__ */ (function () {
    return AdminUsers.value;
})();
var routeAdminPlan = /* #__PURE__ */ (function () {
    return AdminPlan.value;
})();
var routeAccount = /* #__PURE__ */ (function () {
    return Account.value;
})();
var renderDocumentSectionQuery = function (maybeDocumentId) {
    return function (maybeSectionId) {
        var sectionParam = Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
            return "";
        })(function (sectionId) {
            return "section_id=" + Ouroboros_Programs_UrlEncoding["encodeURIComponent"](Ouroboros_Models_Brands_SectionID.unwrap(sectionId));
        })(maybeSectionId);
        var docParam = Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
            return "";
        })(function (docId) {
            return "document_id=" + Ouroboros_Programs_UrlEncoding["encodeURIComponent"](Ouroboros_Models_Brands_DocumentID.unwrap(docId));
        })(maybeDocumentId);
        var $35 = docParam === "" && sectionParam === "";
        if ($35) {
            return "";
        };
        var $36 = docParam !== "" && sectionParam !== "";
        if ($36) {
            return "?" + (docParam + ("&" + sectionParam));
        };
        var $37 = docParam !== "";
        if ($37) {
            return "?" + docParam;
        };
        return "?" + sectionParam;
    };
};
var renderRoute = function (route) {
    var $38 = $foreign.isFunction(route);
    if ($38) {
        return Effect_Unsafe.unsafePerformEffect($foreign.traceInvalidRoute(route));
    };
    if (route instanceof Home) {
        return "/";
    };
    if (route instanceof Login) {
        return "/login";
    };
    if (route instanceof CreateAccount) {
        return "/create-account";
    };
    if (route instanceof PasswordResetRequest) {
        return "/reset-password";
    };
    if (route instanceof PasswordResetComplete) {
        return "/reset-password/complete";
    };
    if (route instanceof EmailVerify) {
        return "/account/verify";
    };
    if (route instanceof InviteAccept) {
        return "/invite/accept";
    };
    if (route instanceof DocumentSelection) {
        return "/workspace/documents";
    };
    if (route instanceof PageCounter) {
        return "/tools/page-counter";
    };
    if (route instanceof ProjectPageCounter) {
        return "/workspace/clients/" + (Ouroboros_Models_Brands_ClientID.unwrap(route.value0) + ("/projects/" + (Ouroboros_Models_Brands_ProjectID.unwrap(route.value1) + "/page-counter")));
    };
    if (route instanceof Clients) {
        return "/workspace/clients";
    };
    if (route instanceof ClientsExplorer) {
        return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
            return "/workspace/clients";
        })(function (client) {
            return "/workspace/clients/" + (Ouroboros_Models_Brands_ClientID.unwrap(client) + Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
                return "/projects";
            })(function (project) {
                return "/projects/" + Ouroboros_Models_Brands_ProjectID.unwrap(project);
            })(route.value1));
        })(route.value0);
    };
    if (route instanceof DocumentCreation) {
        return "/workspace/create";
    };
    if (route instanceof Feedback) {
        return "/workspace/feedback";
    };
    if (route instanceof SdeWorkbook) {
        return "/tools/sde-workbook";
    };
    if (route instanceof Account) {
        return "/workspace/account";
    };
    if (route instanceof AdminUsers) {
        return "/workspace/admin/users";
    };
    if (route instanceof AdminPlan) {
        return "/workspace/admin/plan";
    };
    if (route instanceof Review) {
        return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
            return "/document/review";
        })(function (docId) {
            return "/document/review/" + Ouroboros_Models_Brands_DocumentID.unwrap(docId);
        })(route.value0);
    };
    if (route instanceof DocumentPrompt) {
        return "/document/prompt?question=" + Ouroboros_Programs_UrlEncoding["encodeURIComponent"](Ouroboros_Models_Brands_ProbingQuestions.unwrap(route.value0));
    };
    if (route instanceof DocumentRefine) {
        return "/document/refine" + renderDocumentSectionQuery(route.value0)(route.value1);
    };
    if (route instanceof DocumentFinalEdits) {
        return "/document/final-edits" + renderDocumentSectionQuery(route.value0)(route.value1);
    };
    if (route instanceof DocumentDetailsPrompt) {
        return "/document/details?question=" + Ouroboros_Programs_UrlEncoding["encodeURIComponent"](Ouroboros_Models_Brands_ProbingQuestions.unwrap(route.value0));
    };
    if (route instanceof ChooseSubscription) {
        return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
            return "/payment/choose";
        })(function (value) {
            return "/payment/choose?status=" + Ouroboros_Programs_UrlEncoding["encodeURIComponent"](Ouroboros_Models_Brands_JwtSubscriptionStatus.unwrap(value));
        })(route.value0);
    };
    if (route instanceof PaymentSetup) {
        return "/payment/setup?setup_intent_secret=" + Ouroboros_Programs_UrlEncoding["encodeURIComponent"](route.value0);
    };
    if (route instanceof DemographicSurvey) {
        return "/payment/demographic?promo_code=" + Ouroboros_Programs_UrlEncoding["encodeURIComponent"](Ouroboros_Models_Brands_PromoCode.unwrap(route.value0));
    };
    if (route instanceof ListingInferenceReviewPortal) {
        return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
            return "/listing/inference/review";
        })(function (v) {
            return "/listing/inference/review/" + Ouroboros_Programs_UrlEncoding["encodeURIComponent"](v);
        })(route.value0);
    };
    if (route instanceof ContextPreviewConsole) {
        return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
            return "/tools/context-preview";
        })(function (v) {
            return "/tools/context-preview/" + Ouroboros_Programs_UrlEncoding["encodeURIComponent"](v);
        })(route.value0);
    };
    if (route instanceof StatementClassifier) {
        return "/tools/statement-classifier";
    };
    throw new Error("Failed pattern match at Ouroboros.Programs.Routes (line 109, column 5 - line 176, column 59): " + [ route.constructor.name ]);
};
export {
    Home,
    Login,
    CreateAccount,
    PasswordResetRequest,
    PasswordResetComplete,
    EmailVerify,
    InviteAccept,
    DocumentSelection,
    PageCounter,
    ProjectPageCounter,
    Clients,
    ClientsExplorer,
    DocumentCreation,
    Feedback,
    SdeWorkbook,
    Account,
    AdminUsers,
    AdminPlan,
    Review,
    DocumentPrompt,
    DocumentRefine,
    DocumentFinalEdits,
    DocumentDetailsPrompt,
    ChooseSubscription,
    PaymentSetup,
    DemographicSurvey,
    ListingInferenceReviewPortal,
    ContextPreviewConsole,
    StatementClassifier,
    renderRoute,
    routeHome,
    routeLogin,
    routeCreateAccount,
    routePasswordResetRequest,
    routePasswordResetComplete,
    routeEmailVerify,
    routeInviteAccept,
    routeDocumentSelection,
    routePageCounter,
    routeProjectPageCounter,
    routeClients,
    routeClientsExplorer,
    routeClientsExplorerWithClient,
    routeClientsExplorerWithProject,
    routeDocumentCreation,
    routeFeedback,
    routeSdeWorkbook,
    routeAccount,
    routeAdminUsers,
    routeAdminPlan,
    routeReview,
    routeReviewWithDocument,
    routeDocumentPrompt,
    routeDocumentRefine,
    routeDocumentRefineWithContext,
    routeDocumentFinalEdits,
    routeDocumentFinalEditsWithContext,
    routeDocumentDetailsPrompt,
    routeChooseSubscription,
    routeChooseSubscriptionWithStatus,
    routePaymentSetup,
    routeDemographicSurvey,
    routeListingInferenceReviewPortal,
    routeListingInferenceReviewPortalWithListing,
    routeContextPreviewConsole,
    routeContextPreviewConsoleWithListing,
    routeStatementClassifier,
    tsBridgeRoute
};
//# sourceMappingURL=index.js.map
